/* @jsx h */
import { defineComponent, h, type PropType } from "vue";
import { RightSheet } from "@lemmonhq/uikit";
import type { Service, ServiceSchedule } from "@lemmonhq/types";
import { ServiceDaySelect } from "./ServiceDaySelect";

export const ServiceScheduleSheet = defineComponent({
  name: "ServiceScheduleSheet",
  props: {
    service: {
      type: Object as PropType<Service | null>,
      default: null,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
    onClose: {
      type: Function as PropType<() => void>,
      required: true,
    },
    onChange: {
      type: Function as PropType<(days: ServiceSchedule) => void>,
      required: true,
    },
  },
  setup(props) {
    return () => (
      <RightSheet
        isOpen={props.isOpen}
        title={
          <div class="min-w-0">
            <h2 class="truncate text-base font-bold text-base-content">
              Schedule
            </h2>
            <p class="truncate text-xs text-base-content/45">
              {props.service?.name ?? "Service"}
            </p>
          </div>
        }
        onClose={props.onClose}
        width="480px"
        height="calc(100dvh - 2rem)"
        disableBottomSheet
      >
        <div class="flex min-h-0 flex-1 flex-col">
          <div class="min-h-0 flex-1 overflow-y-auto px-5 py-5">
            <ServiceDaySelect
              value={props.service?.days ?? {}}
              onChange={props.onChange}
            />
          </div>

          <div class="flex items-center justify-end gap-2 border-t border-base-200 bg-base-100 px-5 py-3">
            <button
              type="button"
              class="btn btn-primary btn-sm gap-1.5"
              onClick={props.onClose}
            >
              <span class="material-symbols-outlined text-base">check</span>
              Done
            </button>
          </div>
        </div>
      </RightSheet>
    );
  },
});
